type appLabels = {
  APP_HUMAN_VERSION: string;
  APP_HUMAN_NAME: string;
  APP_HASH: string;
};

const LABELS: appLabels = {
  APP_HUMAN_VERSION: process.env.APP_VERSION_HUMAN || '0000.00.00',
  APP_HUMAN_NAME: 'Iron',
  APP_HASH: process.env.STOCKX_VERSION || '0.0.0', // Git Sha
};

export default LABELS;
